import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PLACEHOLDER_ROUTE_ACCOUNTID } from '../../../services/customer-store.service';
import { ALLOWED_KEYS, StorageService } from '../../../services/storage.service';

@Component({
    selector: 'bdo-contract-edit-auth',
    templateUrl: './contract-edit-auth.component.html',
    styleUrls: ['./contract-edit-auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractEditAuthComponent implements OnInit {

  public placeholderAccountId : string = PLACEHOLDER_ROUTE_ACCOUNTID;

  ngOnInit(): void {
    StorageService.clearValues([ALLOWED_KEYS.AUTH_DATA]);
  }
}
